const pic=[
    {
        id:1,
        title:'To-do List',
        converImg: require("../components/Card/Todo.png"),
        url:"/list"
    },
    {
        id:2,
        title:'Tenzies Game',
        converImg: require("../components/Card/game.jpeg"),
        url:"/game"
    },
    {
        id:3,
        title:'Image Search and Production ',
        converImg: require("../components/Card/Meme.png"),
        url:"/search"
    },
    // {
    //     id:4,
    //     title:'Small Calculator',
    //     converImg: require("../components/Card/Builiding.jpg"),
    //     url:"/calculator"
    // }
]
export default pic;